import React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../img/Rick_and_Morty_logo.png";

const links = [
  { to: "/", label: "Episodes" },
  { to: "/characters", label: "Characters" },
  { to: "/locations", label: "Locations" },
];

const Header: React.FC = () => {
  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-space-950/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-8 gap-y-3 px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="shrink-0" aria-label="Rick and Morty explorer">
          <img className="h-9 w-auto" src={logo} alt="Rick and Morty" />
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              // `end` keeps the Episodes tab from matching every route.
              end={to === "/"}
              className={({ isActive }) =>
                `rounded-lg px-3 py-2 text-sm font-medium transition ${
                  isActive
                    ? "bg-portal-400/15 text-portal-400"
                    : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
